import API_BASE_URL from '../config/apiBaseUrl';
const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, '');

export const resolveAvatarUrl = (value) => {
  if (!value) return null;
  if (value.startsWith('http') || value.startsWith('blob:') || value.startsWith('data:')) {
    return value;
  }
  const normalized = value.startsWith('/') ? value : `/${value}`;
  return `${API_ORIGIN}${normalized}`;
};
